import React from 'react';
import { UsersIcon, PhoneIcon, MailIcon } from 'lucide-react';
const contacts = [{
  name: 'Chip Marks',
  role: 'President',
  phone: '248-787-4848',
  email: 'Clubpresident@fentonlakes.com'
}, {
  name: 'Andy Shute',
  role: 'Vice President, Operations',
  phone: '248-345-4944',
  email: 'Clubvp_Operations@fentonlakes.com'
}, {
  name: 'Jeff Lane',
  role: 'Vice President, Marketing',
  phone: '810-750-0655',
  email: 'Clubvp_Marketing@fentonlakes.com'
}, {
  name: 'Paul Hales',
  role: 'Vice President, Finance',
  phone: '586-764-0580',
  email: 'Clubvp_Finance@fentonlakes.com'
}, {
  name: 'Regina Landon',
  role: 'Banquet Hall Rental Agent',
  phone: '810-938-6008',
  email: 'BanquetHallMgr@fentonlakes.com'
}, {
  name: 'Jeff Lane',
  role: 'Junior Rifle Manager',
  phone: '810-750-0655',
  email: 'ClubJrRifleMgr@fentonlakes.com'
}, {
  name: 'Larry Andrykovich',
  role: 'Indoor Range Manager',
  phone: '810-240-8610',
  email: 'IndoorRngMgr@fentonlakes.com'
}, {
  name: 'Andy Shute',
  role: 'Sporting Clays Manager',
  phone: '248-345-4944',
  email: 'ClaysMgr@fentonlakes.com'
}, {
  name: 'Joe Martonosi',
  role: 'Archery Manager',
  phone: '989-906-0755',
  email: 'ClubArcheryMgr@fentonlakes.com'
}, {
  name: 'John Wiley',
  role: 'Chief Firearms Instructor',
  phone: '810-222-9942',
  email: 'FLSCGunTeacher@fentonlakes.com'
}, {
  name: 'Jason Hartell',
  role: 'Membership Manager',
  phone: '248-470-7497',
  email: 'ClubMembershipMgr@fentonlakes.com'
}, {
  name: 'Mike Ligenza',
  role: 'Outdoor Ranges Manager',
  phone: '248-790-3225',
  email: 'OutdoorRngMgr@fentonlakes.com'
}, {
  name: 'Frank Ouellette',
  role: 'PPC Coordinator',
  phone: '248-459-0506',
  email: 'ClubPPCmgr@fentonlakes.com'
}, {
  name: 'Karl Schuneman',
  role: 'Magnetic Access Card Mgr.',
  phone: '586-588-0158',
  email: 'ClubAccessKeyMgr@fentonlakes.com'
}, {
  name: 'Chris Sorgatz',
  role: 'Steel Challenge Manager',
  phone: '248-953-6150',
  email: 'SteelChallenge@fentonlakes.com'
}];
export function ContactDirectory() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-810">
      <div className="max-w-5xl mx-auto px-4 md:px-8 pt-12" data-id="element-811">
        <div className="flex items-center gap-3 mb-6" data-id="element-812">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
          backgroundColor: 'rgba(30,61,47,0.08)'
        }} data-id="element-813">
            <UsersIcon size={20} style={{
            color: '#1e3d2f'
          }} data-id="element-814" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-815">
            Club Directory
          </h2>
        </div>

        {/* Desktop Table */}
        <div className="bg-white rounded-xl overflow-hidden shadow-sm border hidden md:block" style={{
        borderColor: '#ede9e0'
      }} data-id="element-816">
          <div className="p-4 flex items-center gap-3" style={{
          backgroundColor: '#1e3d2f'
        }} data-id="element-817">
            <UsersIcon size={20} style={{
            color: '#c8a84b'
          }} data-id="element-818" />
            <h3 className="text-base font-bold uppercase" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-819">
              Officers & Managers
            </h3>
          </div>
          <div className="overflow-x-auto" data-id="element-820">
            <table className="w-full text-left border-collapse" data-id="element-821">
              <thead data-id="element-822">
                <tr style={{
                backgroundColor: 'rgba(30,61,47,0.04)'
              }} data-id="element-823">
                  <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                  color: '#1e3d2f',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-824">
                    Name
                  </th>
                  <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                  color: '#1e3d2f',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-825">
                    Role
                  </th>
                  <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                  color: '#1e3d2f',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-826">
                    Phone
                  </th>
                  <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                  color: '#1e3d2f',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-827">
                    Email
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-828">
                {contacts.map((contact, index) => <tr key={`${contact.name}-${contact.role}`} className={index < contacts.length - 1 ? 'border-b' : ''} style={{
                borderColor: '#ede9e0'
              }} data-id="element-829">
                    <td className="p-4 font-semibold text-gray-900" style={{
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-830">
                      {contact.name}
                    </td>
                    <td className="p-4 text-gray-700" style={{
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-831">
                      {contact.role}
                    </td>
                    <td className="p-4" data-id="element-832">
                      <a href={`tel:${contact.phone.replace(/[^\d]/g, '')}`} className="text-gray-800 hover:underline" style={{
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-833">
                        {contact.phone}
                      </a>
                    </td>
                    <td className="p-4" data-id="element-834">
                      <a href={`mailto:${contact.email}`} className="hover:underline text-sm" style={{
                    color: '#1e3d2f',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-835">
                        {contact.email}
                      </a>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden space-y-4" data-id="element-836">
          {contacts.map(contact => <div key={`${contact.name}-${contact.role}`} className="bg-white rounded-xl p-5 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-837">
              <h4 className="text-base font-bold mb-1" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-838">
                {contact.name}
              </h4>
              <p className="text-sm text-gray-500 mb-3" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-839">
                {contact.role}
              </p>
              <div className="flex flex-col gap-2" data-id="element-840">
                <a href={`tel:${contact.phone.replace(/[^\d]/g, '')}`} className="inline-flex items-center gap-2 text-sm font-medium hover:underline" style={{
              color: '#1e3d2f',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-841">
                  <PhoneIcon size={14} data-id="element-842" />
                  {contact.phone}
                </a>
                <a href={`mailto:${contact.email}`} className="inline-flex items-center gap-2 text-sm font-medium hover:underline" style={{
              color: '#1e3d2f',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-843">
                  <MailIcon size={14} data-id="element-844" />
                  {contact.email}
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}